import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseServices';
import './blogcss/blog.css';

// Local images
import keyIngredientsImage from './blogimg/HowToMakeRosemaryOil/key-ingredients.jpg';
import diyImage from './blogimg/HowToMakeRosemaryOil/diy.jpg';
import heatInfusedImage from './blogimg/HowToMakeRosemaryOil/heat-infused.jpg';
import coldInfusedImage from './blogimg/HowToMakeRosemaryOil/cold-infused.jpg';
import applyImage from './blogimg/HowToMakeRosemaryOil/apply.jpg';
import shelfLifeImage from './blogimg/HowToMakeRosemaryOil/shelf-life.jpg';
import frequencyImage from './blogimg/HowToMakeRosemaryOil/frequency.jpg';
import safeImage from './blogimg/HowToMakeRosemaryOil/safe.jpg';
import whyRosemaryImage from './blogimg/HowToMakeRosemaryOil/why-rosemary.jpg';
import scienceImage from './blogimg/HowToMakeRosemaryOil/science.jpg';


function getLocalImageSource(filename) {
  const commaIndex = filename.indexOf(',');
  if (commaIndex !== -1) {
    filename = filename.substring(0, commaIndex);
  }
  const parts = filename.split(/[/\\]/);
  const baseName = parts[parts.length - 1].trim().toLowerCase();

  switch (baseName) {
    case 'key-ingredients.jpg':
      return keyIngredientsImage;
    case 'diy.jpg':
      return diyImage;
    case 'heat-infused.jpg':
      return heatInfusedImage;
    case 'cold-infused.jpg':
      return coldInfusedImage;
    case 'apply.jpg':
      return applyImage;
    case 'shelf-life.jpg':
      return shelfLifeImage;
    case 'frequency.jpg':
      return frequencyImage;
    case 'safe.jpg':
      return safeImage;
    case 'why-rosemary.jpg':
      return whyRosemaryImage;
    case 'science.jpg':
      return scienceImage;
    default:
      return null;
  }
}
const HowToMakeRosemaryOilPage = () => {
  const [article, setArticle] = useState(null);
  const [timestamp, setTimestamp] = useState(null);

  // 1️⃣ Add Meta Tags Dynamically
  useEffect(() => {
    // Set the document title
    document.title = "Best Rosemary Oil Formulas For Hair Growth: Backed By Science";

    // Helper function to add or update meta tags
    const setMetaTag = (attrName, contentValue, useProperty = false) => {
      const key = useProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${key}="${attrName}"]`);

      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(key, attrName);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', contentValue);
    };

    // Standard meta tags
    setMetaTag(
      "description",
      "Discover the proven benefits of rosemary oil for hair growth and scalp health. Learn DIY methods, usage tips, and scientific evidence for thicker, fuller hair."
    );
    setMetaTag(
      "keywords",
      "rosemary oil, hair growth, scalp health, hair thinning, DIY hair oil, rosemary oil shelf life, Pure Health Nexus"
    );

    // Open Graph tags
    setMetaTag(
      "og:title",
      "Best Rosemary Oil Formulas for Hair Growth: Natural & Effective",
      true
    );
    setMetaTag(
      "og:description",
      "Learn how rosemary oil can help you stop hair thinning and promote regrowth naturally. Step-by-step methods, usage instructions, and scientific research included.",
      true
    );
      setMetaTag(
        "og:image",
        "https://purehealthnexus.com/assets/images/key-ingredients.jpg",
        true
      );
    setMetaTag(
      "og:url",
      "https://purehealthnexus.com/how-to-make-rosemary-oil-at-home-for-stronger-healthier-hair-plus-the-science-behind-how-they-work",
      true
    );

    // Twitter Card tags (optional but recommended)
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "Best Rosemary Oil Formulas for Hair Growth: Natural & Effective");
    setMetaTag("twitter:description", "Learn how rosemary oil can help you stop hair thinning and promote regrowth naturally. Step-by-step methods, usage instructions, and scientific research included.");
    setMetaTag("twitter:image", "https://www.example.com/images/key-ingredients.jpg"); 

    // Cleanup on unmount (optional)
    return () => {
      document.title = "Pure Health Nexus";
    };
  }, []);

  // 2️⃣ Fetch the Article from Firestore
  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const colRef = collection(
          db,
          'products',
          'blog',
          'RosemaryOilFormulas'
        );
        const snapshot = await getDocs(colRef);

        if (!snapshot.empty) {
          const docData = snapshot.docs[0].data();
          setArticle(docData);
          setTimestamp(docData.eutimestamp);
        } else {
        }
      } catch (error) {
      }
    };

    fetchArticle();
  }, []);

  if (!article) {
    return <div>Loading...</div>;
  }

  // 3️⃣ Organize Sections for Conclusion & References
  let conclusionSection = null;
  let referenceBlock = null;
  let otherBlocks = [];

  if (article.sections && article.sections.length > 0) {
    article.sections.forEach((section, sectionIndex) => {
      if (section.blocks && section.blocks.length > 0) {
        // If the first block is an h2 titled "Conclusion", set as conclusion
        if (section.blocks[0].tag === 'h2' && section.blocks[0].text === 'Conclusion') {
          conclusionSection = section;
        }
        // If it's the last section, set as references
        else if (sectionIndex === article.sections.length - 1) {
          referenceBlock = section.blocks;
        } else {
          otherBlocks.push(section);
        }
      }
    });
  }

  // 4️⃣ Render Block Function
  const renderBlock = (block, index, isReference = false) => {
    const { tag, text } = block;
    const style = isReference ? { fontSize: '10px', margin: '0' } : {};

    switch (tag) {
      case 'h1':
        return (
          <h1 key={index} className="recipe-h1" style={style}>
            {text}
            <style>{`.recipe-h1::after { left: 8%; }`}</style>
          </h1>
        );
      case 'h2':
        return (
          <React.Fragment key={index}>
            <hr
              style={{ width: '75%', margin: '20px auto', border: '1px solid #e67e00' }}
            />
            <h2 className="recipe-h2" style={style}>
              <span>{text}</span>
            </h2>
          </React.Fragment>
        );
      case 'h3':
        return (
          <React.Fragment key={index}>
            <hr
              style={{ width: '75%', margin: '20px auto', border: '1px solid #e67e00' }}
            />
            <h3 className="recipe-h3" style={style}>
              {text}
            </h3>
          </React.Fragment>
        );
      case 'p':
        return (
          <p key={index} className="recipe-p" style={style}>
            {text}
          </p>
        );
      case 'img': {
        const localImg = getLocalImageSource(text);
        return (
          <div key={index} className="recipe-img">
            <img
              src={localImg ?? text}
              alt={text}
              style={{ maxHeight: '500px', width: 'auto' }}
            />
          </div>
        );
      }
      case 'ul':
        return (
          <ul key={index} className="recipe-ul" style={style}>
            {Array.isArray(text)
              ? text.map((li, liIndex) => <li key={liIndex}>{li}</li>)
              : <li>{text}</li>}
          </ul>
        );
      case 'ol':
        return (
          <ol key={index} className="recipe-ol" style={style}>
            {Array.isArray(text) &&
              text.map((li, liIndex) => {
                if (typeof li === 'object') {
                  return (
                    <li key={liIndex}>
                      {li.text}
                      {li.nested && (
                        <ul>
                          {li.nested.map((nestedItem, nestedIndex) => (
                            <li key={nestedIndex}>{nestedItem}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                } else {
                  return <li key={liIndex}>{li}</li>;
                }
              })}
          </ol>
        );
      case 'hr':
        return (
          <hr
            key={index}
            style={{ width: '75%', margin: '20px auto', border: '1px solid #e67e00' }}
          />
        );
      default:
        return (
          <div key={index} style={style}>
            {text}
          </div>
        );
    }
  };
  // Format the timestamp for display
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };
  // 5️⃣ Render the Page
  return (
    <div className="container">
      <div className="calming-morning-routine">
        {/* Main H1 */}
        {article.h1 && (
          <h1 className="recipe-h1" style={{ position: 'relative' }}>
            {article.h1}
            <style>{`.recipe-h1::after { left: 8%; }`}</style>
          </h1>
        )}
        {timestamp && (
          <p className="timestamp" style={{ textAlign: 'center', color: '#888' }}>
            Updated: {formatTimestamp(timestamp)}
          </p>
        )}
        {/* Render Other Blocks (excluding Conclusion & References) */}
        {otherBlocks.map((section, sectionIndex) => (
          <section key={sectionIndex}>
            {section.blocks &&
              section.blocks.map((block, blockIndex) => renderBlock(block, blockIndex))}
          </section>
        ))}

        {/* Conclusion Section */}
        {conclusionSection && (
          <section>
            {conclusionSection.blocks.map((block, index) => renderBlock(block, index))}
          </section>
        )}

        {/* CTA Button */}
        <button
          className="recipe-button"
          onClick={() => (window.location.href = 'https://purehealthnexus.com/top-rated-vitamins')}
        >
          See Top-Rated Vitamins Here
        </button>

        {/* References Section after Button */}
        {referenceBlock &&
          referenceBlock.map((block, index) => (
            <div className="notranslate" key={index}>
              {renderBlock(block, index, true)}
            </div>
          ))}
        </div>
    </div>
  );
};

export default HowToMakeRosemaryOilPage;
